import psychiatryQuestionSet from "../faq/psychiatryQuestionSet";
import childrenPsychiatryQuestionSet from "../faq/childrenPsychiatry/allQuestions";

export const psychiatryChildren = {
    'meta': {
        'title': 'Psychiatra dziecięcy #city# • Centrum COLLIGO',
        'description': 'Psychiatra dziecięcy #city#: psychiatria dziecięca prowadzona przez doświadczonych lekarzy specjalistów. Krótkie terminy.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'price': {
        'torun': {
            'first': 450,
            'next': 350
        },
        'bydgoszcz': {
            'first': '450',
            'next': '350'
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/psychiatra-dzieci-i-mlodziezy/',
        'title': 'Psychiatra dzieci i młodzieży #cityLocativeIn#',
        'name': 'Konsultacje psychiatryczne dzieci i młodzieży #cityLocativeIn#',
        'heading': 'Psychiatra dzieci i młodzieży #cityLocativeIn#',
        'fullName': 'Konsultacje psychiatryczne dzieci i młodzieży'
    },
    'image': {
        'url': '/images/services/psychiatra-konsultacje-dzieci-i-mlodziezy.webp',
        'width': 886,
        'height': 295,
        'alt': 'Psychiatra dziecięcy'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/psychiatra-konsultacje-dzieci-i-mlodziezy.webp',
            'width': 886,
            'height': 295,
            'alt': 'Psychiatra dziecięcy'
        }
    },
    'faq': childrenPsychiatryQuestionSet
}